// components/callout/callout.js

(function (Drupal, once) {
  'use strict';

  /**
   * Entfernt ein Element optional mit Fade Transition.
   */
  function removeWithTransition(element) {
    const hasFade = element.classList.contains('fade');
    const hasShow = element.classList.contains('show');

    // Wenn fade/show aktiv ist, erst show entfernen und nach transition löschen
    if (hasFade && hasShow) {
      // Trigger "close" Event (Bootstrap-like)
      element.dispatchEvent(new CustomEvent('close.bs.callout', { bubbles: true }));

      element.classList.remove('show');

      const duration = getTransitionDurationFromElement(element);
      window.setTimeout(() => {
        element.remove();
        element.dispatchEvent(new CustomEvent('closed.bs.callout', { bubbles: true }));
      }, duration);
      return;
    }

    // Ohne Transition direkt entfernen
    element.dispatchEvent(new CustomEvent('close.bs.callout', { bubbles: true }));
    element.remove();
    element.dispatchEvent(new CustomEvent('closed.bs.callout', { bubbles: true }));
  }

  /**
   * Liest transition-duration (+ delay) aus dem computed style.
   */
  function getTransitionDurationFromElement(element) {
    const computed = window.getComputedStyle(element);

    const duration = computed.transitionDuration.split(',')[0] || '0s';
    const delay = computed.transitionDelay.split(',')[0] || '0s';

    const durationMs = parseFloat(duration) * (duration.includes('ms') ? 1 : 1000);
    const delayMs = parseFloat(delay) * (delay.includes('ms') ? 1 : 1000);

    // Minimal 0
    return Math.max(0, durationMs + delayMs);
  }

  Drupal.behaviors.calloutDismiss = {
    attach(context) {
      once('callout-dismiss', '[data-bs-dismiss="callout"]', context).forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();

          // target: nächster .callout parent
          const callout = btn.closest('.callout');
          if (!callout) return;

          removeWithTransition(callout);
        });
      });
    }
  };

})(Drupal, once);